<template>
  <div class="content-wrapper">
    <div class="content-header">
      <div
        class="d-flex align-items-center"
        style="border-bottom: 1px solid #5c4a4a17; margin: auto !important"
      >
        <div class="row">
          <div class="col-sm-6 d-flex flex-column align-items-baseline">
            <h1 class="m-0 text-dark">Domains List</h1>
            <ol class="breadcrumb float-sm-left">
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Home' }"
                >Home</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Dashboard' }"
                >Dashboard</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Main Stats' }"
                >Global Stats</router-link
              >
              <li class="breadcrumb-item active">Domains List:</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <v-card>
      <v-card-title class="table-card-header--color height-70 pl-0">
        <!-- Search input -->
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          class="table-search-field--width ml-2"
          single-line
          hide-details
          solo
          dense
        ></v-text-field>
        <!-- Button to download domains list zip -->
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :loading="fileLoading"
              :disabled="fileLoading"
              color="primary"
              class="ml-3 white--text"
              fab
              small
                        v-bind="attrs"
              v-on="on"
              @click="downloadDomainListInZip"
            >
              <v-icon dark> mdi-folder-zip-outline </v-icon>
            </v-btn>
          </template>
          <span>Save in zip format</span>
        </v-tooltip>
        <!-- Button to download domains list -->
        <v-btn
          :loading="fileLoading"
          :disabled="fileLoading"
          color="primary"
          class="ml-3 white--text"
          fab
          small
          @click="downloadDomainList"
        >
          <v-icon dark> mdi-cloud-download </v-icon>
        </v-btn>
        <!-- <v-btn
          :loading="fileLoading"
          :disabled="fileLoading"
          color="primary"
          class="white--text"
          small
          icon
          elevation="2"
          @click="downloadDomainList"
        >
          <v-icon dark>
            mdi-cloud-download
          </v-icon>
        </v-btn> -->
      </v-card-title>
      <!-- Data Table -->
      <v-data-table
        :headers="headers"
        :items="domainList[0]"
        :custom-filter="filteredDomains"
        :search="search"
        :loading="loading"
      ></v-data-table>
    </v-card>

    <!-- Failure Snackbar -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <FailureSnackbar
        v-if="failure"
        @update-failure="handleUpdateToFailureSnackbar"
        :message="failureText"
      />
    </transition>
  </div>
</template>

<script>
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import Domains from "../../apis/Domains";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import common from "../../mixins/common";

export default {
  name: "DomainList",
  components: {
    FailureSnackbar,
  },
  mixins: [common],
  data() {
    return {
      failure: false,
      failureText: "",

      search: "",
      offset: 0,
      limit: 1000,
      fileLoading: false,
      loading: true,
      domainList: [],
      headers: [
        {
          text: "Id",
          value: "id",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Website Id",
          value: "website_id",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Url",
          value: "url",
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Created At",
          value: "created_at",
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Updated At",
          value: "updated_at",
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Deleted At",
          value: "deleted_at",
          divider: true,
          class: "table-header--color",
        },
      ],
    };
  },
  created() {
    this.getDomainList(this.limit, this.offset).then((response) => {
      this.domainList.push(response);
    });
  },
  methods: {
    /**
     * Download Domains List
     */
    downloadDomainList() {
      this.fileLoading = true;

      setTimeout(() => {
        this.fileLoading = false;
      }, 2000);

      if (this.domainList.length) {
        // temp solution
        let js = this.domainList[0];
        let ws = XLSX.utils.json_to_sheet(js);
        let wb = {
          Sheets: {
            Domains: ws,
          },
          SheetNames: ["Domains"],
        };

        let excelBuffer = XLSX.write(wb, {
          bookType: "csv",
          type: "array",
          FS: ";"
        });
        let data = new Blob([excelBuffer], {
          type: "text/csv",
          FS: ";"
        });

        saveAs(data, `domains_pmr`);
      } else {
        this.failure = true;
        this.failureText = "No data to download!";
      }
    },
    downloadDomainListInZip() {
      const formData = new FormData();
      this.fileLoading = true;

      formData.append("filename", "pm");
      this.domainList[0].forEach(({ website_id }) => {
        formData.append("website_ids[]", website_id);
      })

        Domains.generateJavaScriptZipByDomains(formData)
          .then((response) => {
            const date = new Date().toJSON();
            const blob = new Blob([response.data], { type: 'application/zip' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);

            const disposition = response.headers['content-disposition'];
            const fileNameMatch = disposition && disposition.match(/filename="?(.+?)"?$/);
            const fileName = fileNameMatch ? fileNameMatch[1] : `pm.js_files_.${date}.zip`;

            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
        .catch((error) => {
          this.failureText = error?.response?.message || error;
          this.failure = true;
        })
        .finally(() => {
          this.fileLoading = false;
        })
    },
    /**
     * /**
     * @param value
     *
     * /**
     * @param {string} search
     *
     * Custom filter for data table
     */
    filteredDomains(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.includes(search)
      );
    },
    /**
     * @param {number} limit
     *
     * @param {number} offset
     *
     * @return {Promise} - Promise object represents the list of domains
     */
    getDomainList(limit, offset) {
      let responseArray = [];

      this.loading = true;

      return new Promise((resolve, reject) => {
        Domains.get(
          `?limit=${limit}&offset=${offset}&select=id,website_id,url,created_at,updated_at,deleted_at&with[domain_tags]=id,name&castRelationsToString[domain_tags]=name`
        )
          .then((response) => {
            return response.data.data;
          })
          .then((domains) => {
            if (domains.length < limit) {
              responseArray.push(domains);
              responseArray = responseArray.flat(2);
              resolve(responseArray);

              queueMicrotask(() => {
                this.loading = false;
              });
            } else if (domains.length === limit) {
              responseArray.push(domains);
              this.getDomainList(limit, ++offset);
            }
          })
          .catch((error) => {
            reject(error);

            queueMicrotask(() => {
              this.loading = false;
            });

            if (error.response.status == 401 || error.response.status == 419) {
              this.router.replace({ name: "Login" });
            }
          });
      });
    },
  },
};
</script>
